<div class="container">
    <div class="barra-progreso">
        <div class="paso" *ngFor="let paso of barraProgreso; let i = index" [class.completado]="i + 1 <= pasoActual">
        </div>
    </div>
    <ng-container *ngIf="isCurrentStep(1)">
        <div id="datos-personales">
            <h2>{{'contratar.datos-personales.titulo' | translate}}</h2>

            <form action="" [formGroup]="formDatosPersonales" id="formulario-datos-personales">
                <div class="form-control-datos">
                    <label for="nombre">{{'contratar.datos-personales.campo.nombre' | translate}} <span>*</span></label>
                    <input id="nombre" name="nombre" type="text" placeholder="Nombre" formControlName="nombre"
                        class="input-form-control">
                    <div *ngIf="getFormDatosPersonales['nombre'].errors" class="content-validacion-form mt-0">
                        <div>{{getError(getFormDatosPersonales['nombre'], formularioDatos)}}</div>
                    </div>
                </div>
                <div class="form-control-datos">
                    <label for="primer-apellido">{{'contratar.datos-personales.campo.primer-apellido' | translate}}
                        <span>*</span></label>
                    <input id="primer-apellido" name="primer-apellido" type="text" placeholder="Primer Apellido"
                        formControlName="primerApellido" class="input-form-control">
                    <div *ngIf="getFormDatosPersonales['primerApellido'].errors" class="content-validacion-form  mt-0">
                        <div>{{getError(getFormDatosPersonales['primerApellido'], formularioDatos)}}</div>
                    </div>
                </div>

                <div class="form-control-datos">
                    <label for="segundo-apellido">{{'contratar.datos-personales.campo.segundo-apellido' |
                        translate}}</label>
                    <input id="segundo-apellido" name="segundo-apellido" type="text" placeholder="Segundo Apellido"
                        formControlName="segundoApellido" class="input-form-control">
                    <div *ngIf="getFormDatosPersonales['segundoApellido'].errors" class="content-validacion-form  mt-0">
                        <div>{{getError(getFormDatosPersonales['segundoApellido'], formularioDatos)}}</div>
                    </div>
                </div>
                <div class="form-control-datos">
                    <label for="profesion">{{'contratar.datos-personales.campo.profesion' | translate}}
                        <span>*</span></label>
                    <input id="profesion" name="profesion" type="text" placeholder="Profesion"
                        formControlName="profesion" class="input-form-control">
                    <div *ngIf="getFormDatosPersonales['profesion'].errors" class="content-validacion-form  mt-0">
                        <div>{{getError(getFormDatosPersonales['profesion'], formularioDatos)}}</div>
                    </div>
                </div>

                <div class="form-control-datos">
                    <label for="tipoSexo">{{'contratar.datos-personales.campo.sexo' | translate}} <span>*</span></label>
                    <select id="tipoSexo" name="tipoSexo" formControlName="tipoSexo" class="input-form-control w-100">
                        <option value="">{{ 'Seleccionar' | translate }}</option>
                        <option *ngFor="let sexo of tiposSexo" [value]="sexo.id">{{ sexo.descripcion }}</option>
                    </select>
                    <div *ngIf="getFormDatosPersonales['tipoSexo'].errors" class="content-validacion-form  mt-0">
                        <div>{{getError(getFormDatosPersonales['tipoSexo'], formularioDatos)}}</div>
                    </div>
                </div>



                <div class="form-control-datos">
                    <label for="telefonoDP">{{'contratar.datos-personales.campo.telefono' | translate}}
                        <span>*</span></label>
                    <input id="telefonoDP" name="telefonoDP" type="text" placeholder="(+34) 600 11 22 33"
                        formControlName="telefono" class="input-form-control">
                    <div *ngIf="getFormDatosPersonales['telefono'].errors" class="content-validacion-form  mt-0">
                        <div>{{getError(getFormDatosPersonales['telefono'], formularioDatos)}}</div>
                    </div>
                </div>
                <div
                    [ngClass]="{'hipoteca-true': (poliza.tipoPoliza.id === 2), 'hipoteca-false': !(poliza.tipoPoliza.id === 2)}">
                    <div class="form-control-datos">
                        <label for="identificacion">{{'contratar.datos-personales.campo.dni' | translate}}
                            <span>*</span></label>
                        <input id="identificacion" name="identificacion" type="text" placeholder="000000000X"
                            formControlName="identificacion" class="input-form-control">
                        <div *ngIf="getFormDatosPersonales['identificacion'].errors"
                            class="content-validacion-form  mt-0">
                            <div>{{getError(getFormDatosPersonales['identificacion'], formularioDatos)}}</div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="content-validacion-form-general text-center">
                <span>{{mensajeValidacionForm}}</span>
            </div>
            <div class="botones">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'"
                    [estilo]="'border'" [routerLink]=[CONSTANTES.PATH_COLECTIVOS_3_MEJOR_PRECIO]>
                </app-generic-field-button-next-back>
                <app-generic-field-button-next-back class="" [direccion]="'next'" [texto]="'Continuar'"
                    [estilo]="'simple'" (click)="validarDatosPersonales()">
                </app-generic-field-button-next-back>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isCurrentStep(2)">
        <div id="datos-beneficiario">
            <h2>{{'contratar.beneficiarios.titulo' | translate}}</h2>
            <section [formGroup]="formBeneficiarios">
                <ng-container formArrayName="beneficiarioItems">
                    <ng-container *ngFor="let item of beneficiarioItems.controls; let i = index; let isLast=last">
                        <section *ngIf="(poliza.tipoPoliza.id === 2) && i === 0" [formGroupName]="i"
                            class="beneficiario">
                            <div class="nombre-numero-prestamo">
                                <div class="nombre-banco">
                                    <label for="nombre{{i}}">{{'contratar.beneficiarios.hipoteca.nombre-banco' |
                                        translate}}<span>*</span></label>
                                    <input id="nombre{{i}}" name="nombre{{i}}" type="text" class="input-form-control"
                                        placeholder="Nombre del Banco" formControlName="nombreBanco">
                                    <div *ngIf="beneficiarioItems.controls[i].get('nombreBanco')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('nombreBanco'),
                                            formularioBeneficiariosHip)}}</div>
                                    </div>
                                </div>
                                <div class="numero-prestamo">
                                    <label for="nombre{{i}}">{{'contratar.beneficiarios.hipoteca.numero-prestamo' |
                                        translate}}<span>*</span></label>
                                    <input id="nombre{{i}}" name="nombre{{i}}" type="text" class="input-form-control"
                                        placeholder="Número de préstamo" formControlName="numeroPrestamo">
                                    <div *ngIf="beneficiarioItems.controls[i].get('numeroPrestamo')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('numeroPrestamo'),
                                            formularioBeneficiariosHip)}}</div>
                                    </div>
                                </div>
                            </div>
                            <label for="reciboHipoteca">{{'contratar.beneficiarios.hipoteca.recibo-hipoteca' |
                                translate}}</label>
                            <div class="recibo-hipoteca upload-container">
                                <input id="reciboHipoteca" name="reciboHipoteca" type="file"
                                    formControlName="reciboHipoteca" (change)="onFileChangeRecibo($event)">
                            </div>
                            <div *ngIf="nombreArchivoRecibo" class="detalle-archivo">
                                <p class="nombre-archivo">{{ nombreArchivoRecibo }}</p>
                            </div>
                        </section>

                        <section *ngIf="!(poliza.tipoPoliza.id === 2) || i > 0" [formGroupName]="i"
                            class="beneficiario">
                            <div class="nombre-porcentaje">
                                <div class="nombre-beneficiario">
                                    <label for="nombre{{i}}">{{'contratar.beneficiarios.familia.nombre-completo' |
                                        translate}} <span>*</span></label>
                                    <input id="nombre{{i}}" name="nombre{{i}}" type="text" class="input-form-control"
                                        placeholder="Nombre y Apellidos" formControlName="nombreCompleto">
                                    <div *ngIf="beneficiarioItems.controls[i].get('nombreCompleto')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('nombreCompleto'),
                                            formularioBeneficiarios)}}</div>
                                    </div>
                                </div>
                                <div *ngIf="!(poliza.tipoPoliza.id === 2)" class="porcentaje">
                                    <label for="porcentaje{{i}}">{{'contratar.beneficiarios.porcentaje' |
                                        translate}}</label>
                                    <input id="porcentaje{{i}}" name="porcentaje{{i}}" type="number" placeholder="100%"
                                        formControlName="porcentaje" min="0" max="100" class="input-form-control">
                                    <div *ngIf="beneficiarioItems.controls[i].get('porcentaje')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('porcentaje'),
                                            formularioBeneficiarios)}}</div>
                                    </div>
                                </div>
                                <div class="btn-delete-beneficiario" *ngIf="beneficiarioItems.length > 1 && i > 0">
                                    <button class="material-symbols-outlined primary-color"
                                        (click)="eliminarBeneficiario(i)">delete</button>
                                </div>
                            </div>
                            <div class="nombre-porcentaje">
                                <!-- DNI -->
                                <div class="dni-beneficiario">
                                    <label for="dni{{i}}">{{'texto.dni.nie' | translate}}</label>
                                    <input id="dni{{i}}" type="text" placeholder="" class="input-form-control"
                                        formControlName="dni">
                                    <div *ngIf="beneficiarioItems.controls[i].get('dni')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('dni'),
                                            formularioBeneficiarios)}}</div>
                                    </div>
                                </div>
                                <!-- TIPO RELACIÓN -->
                                <div class="relacion-beneficiario">
                                    <label for="tipoRelacion{{i}}">{{'cambiar-beneficiarios.relacion' | translate}}
                                        <span>*</span></label>
                                    <input required id="tipoRelacion{{i}}" name="tipoRelacion{{i}}" type="text"
                                        placeholder="Relación" formControlName="tipoRelacion"
                                        class="input-form-control w-100">
                                    <div *ngIf="beneficiarioItems.controls[i].get('tipoRelacion')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('tipoRelacion'),
                                            formularioBeneficiarios)}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="email-comunicar">
                                <div class="email-beneficiario">
                                    <label for="email{{i}}">{{'contratar.beneficiarios.email' | translate}}</label>
                                    <input id="email{{i}}" name="email{{i}}" type="text"
                                        placeholder="direccion@email.com" formControlName="email"
                                        class="input-form-control">
                                    <div *ngIf="beneficiarioItems.controls[i].get('email')?.errors"
                                        class="content-validacion-form mt-0">
                                        <div>{{getError(beneficiarioItems.controls[i].get('email'),
                                            formularioBeneficiarios)}}</div>
                                    </div>
                                </div>
                                <div class="checkbox-container">
                                    <input class="custom-checkbox" type="checkbox" formControlName="comunicarEmail"
                                        id="comunicar-beneficiario{{i}}" name="comunicar-beneficiario{{i}}"
                                        (ngModelChange)="cambiarValidacionEmail($event,i)">
                                    <label class="comunicar-txt"
                                        for="comunicar-beneficiario{{i}}">{{'contratar.beneficiarios.comunicar-beneficiario'
                                        | translate}}</label>
                                </div>
                            </div>
                        </section>

                        <hr *ngIf="!isLast">
                    </ng-container>
                </ng-container>

                <div id="content-btn-add-benef">
                    <button class="add-beneficiario" (click)="agregarBeneficiario()">
                        <span class="material-symbols-outlined primary-color">
                            add_circle
                        </span>
                        <p>{{'contratar.beneficiarios.agregar' | translate}}</p>
                    </button>
                </div>
                <div class="checkbox-container-comunicado">
                    <input type="checkbox" class="custom-checkbox" id="comunicar-beneficiarios"
                        name="comunicar-beneficiarios" [(ngModel)]="comunicarBeneficiarios"
                        [ngModelOptions]="{standalone: true}">
                    <label for="comunicar-beneficiarios"
                        class="comunicar-beneficiarios">{{'contratar.beneficiarios.autorizacion' | translate}} <a
                            (click)="abrirModalInformativo($event)"
                            class="enlace-politica-privacidad">{{'contratar.beneficiarios.politicas.ver' |
                            translate}}</a></label>
                </div>
                <div class="content-validacion-form-general text-center mb-1">
                    <span>{{mensajeValidacionForm}}</span>
                </div>
                <div class="botones">
                    <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'"
                        [estilo]="'border'" (click)="goToPreviousStep()">
                    </app-generic-field-button-next-back>
                    <app-generic-field-button-next-back class="ml-1" [direccion]="'next'" [texto]="'Continuar'"
                        [estilo]="'simple'" (click)="validarBeneficiarios()">
                    </app-generic-field-button-next-back>
                </div>
            </section>
        </div>
    </ng-container>

    <ng-container *ngIf="isCurrentStep(3)">
        <div id="datos-bancarios">
            <h2>{{'contratar.cuenta-bancaria.titulo' | translate}}</h2>

            <form action="" [formGroup]="formCuentaBancaria">
                <div class="form-control">
                    <div class="form-control">
                        <label for="periodicidad">{{'contratar.cuenta-bancaria.periodicidad' | translate}}
                            <span>*</span></label>
                        <select id="periodicidad" name="periodicidad" formControlName="periodicidad"
                            class="input-selected input-form-control w-100">
                            <option *ngFor="let tipoPeriodicidad of tiposPeriodicidad" [value]="tipoPeriodicidad.id">
                                {{ tipoPeriodicidad.descripcion }}</option>
                        </select>
                    </div>
                    <label for="titularCuenta">{{'contratar.cuenta-bancaria.titular' | translate}}
                        <span>*</span></label>
                    <input id="titularCuenta" name="titularCuenta" type="text" placeholder="Nombre y Apellidos"
                        formControlName="titularCuenta" class="input-form-control">
                    <div *ngIf="getFormCuentaBancaria['titularCuenta'].errors" class="content-validacion-form mt-0">
                        <div>{{getError(getFormCuentaBancaria['titularCuenta'], formularioCuentaBan)}}</div>
                    </div>
                </div>
                <div class="form-control">
                    <label for="ibanCuenta">{{'contratar.cuenta-bancaria.iban' | translate}} <span>*</span></label>
                    <input id="ibanCuenta" name="ibanCuenta" type="text" placeholder="ES91 2100 0418 4502 0005 1332"
                        formControlName="ibanCuenta" class="input-form-control">
                    <div *ngIf="getFormCuentaBancaria['ibanCuenta'].errors" class="content-validacion-form mt-0">
                        <div>{{getError(getFormCuentaBancaria['ibanCuenta'], formularioCuentaBan)}}</div>
                    </div>
                </div>
            </form>
            <div class="content-validacion-form-general text-center mb-1">
                <span>{{mensajeValidacionForm}}</span>
            </div>

            <div class="botones">
                <app-generic-field-button-next-back class="mr-1" [direccion]="'back'" [texto]="'Atrás'"
                    [estilo]="'border'" (click)="goToPreviousStep()">
                </app-generic-field-button-next-back>
                <app-generic-field-button-next-back class="ml-1" [direccion]="'next'" [texto]="'Finalizar'"
                    [estilo]="'simple'" (eventoClick)="finalizar()">
                </app-generic-field-button-next-back>
            </div>
        </div>
        <p id="info" class="txt-xsmall mt-1">{{'mejor-precio.cobros' | translate}}</p>
    </ng-container>
</div>